import React from "react";
import styled from "styled-components";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ACCENT_PRIMARY,
  BRAND,
  GRAY_LIGHTEST,
  TEXT_PRIMARY
} from "@streeteasy/design-system/colors";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import TextAction, {
  textActionTypography
} from "@streeteasy/design-system/text-action";
import { Caps } from "@streeteasy/design-system/typography";

export const AgentLink = styled(TextAction).attrs({
  underlined: false,
  typography: textActionTypography.BODY_LF
})`
  color: ${TEXT_PRIMARY};
  cursor: pointer;
  transition: color 200ms;
  font-size: ${({ agent_dropdown }) => (agent_dropdown ? "14px" : "18px")};
  padding: ${({ agent_dropdown }) => (agent_dropdown ? "10px 15px" : "")};
  display: block;

  &:hover,
  &:active,
  &:focus {
    color: ${ACCENT_PRIMARY};
    background: ${({ agent_dropdown }) =>
      agent_dropdown ? GRAY_LIGHTEST : "none"};
  }
`;

const FaArrowUpRightFromSquare = props => (
  <FontAwesomeIcon icon={faArrowUpRightFromSquare} {...props} />
);

export const LinkOutIcon = styled(FaArrowUpRightFromSquare).attrs({
  alt: "Link out",
  color: "currentColor",
  size: componentSizes.SM
})`
  margin-left: 5px;
  vertical-align: -1px;
  height: 12px;
`;

export const CallOut = styled(Caps)`
  color: ${BRAND};
  display: inline-block;
  margin-left: 5px;
  vertical-align: 1px;
`;
